export const New = () => import("./New.vue");
export const Edit = () => import("./Edit.vue");
export const List = () => import("./List.vue");
